import { equal } from '@ember/object/computed';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import CatalogObjectReference from '@square/dashboard-items-data/models/invoices/cart/catalog-object-reference';
import { ObjectId } from '@square/dashboard-protos/models/squareup/api/sync/sync';
import Intermission from '@square/dashboard-items-data/models/intermission';
import { PricingType as VariationModelPricingType } from '@square/dashboard-items-data/models/item-variation';
import Enum from '@square/dashboard-utilities/utils/enum';
import Money from '@square/dashboard-money/models/money';
import LegacyMoney from '@square/dashboard-data/utils/legacy-money';

// squareup.api.items.PricingType
export const PricingType = new Enum(['FIXED_PRICING', 'VARIABLE_PRICING']);

// squareup.api.items.ItemVariation
export default ProtoBaseModel.extend({
  id: attr(String),
  item: attr(ObjectId),
  name: attr(String),
  pricingType: attr(PricingType),
  price: attr(LegacyMoney),
  sku: attr(String),
  measurementUnitToken: attr(String),
  catalogObjectReference: attr(CatalogObjectReference),
  serviceDuration: attr(Number),
  intermissions: repeated(Intermission, {
    defaultValue: () => []
  }),
  resourceTokens: attr(Array),
  transitionTime: attr(Number),
  isFixedPriced: equal('pricingType', PricingType.FIXED_PRICING),
  isVariablePriced: equal('pricingType', PricingType.VARIABLE_PRICING)
}).reopenClass({
  createFor(itemVariation, unitToken) {
    const {
      id,
      name,
      sku,
      measurementUnit
    } = itemVariation;
    const pricingType = VariationModelPricingType.deserialize(itemVariation.getUnitAttribute(unitToken, 'pricing_type'));
    const priceUnitOverride = itemVariation.getUnitOverride(unitToken, 'price');
    let price = priceUnitOverride ? Money.fromCents(priceUnitOverride.cents) : itemVariation.price;
    if (pricingType === VariationModelPricingType.VARIABLE_PRICING) {
      price = null;
    }
    return this.create({
      id,
      name,
      pricingType,
      price,
      sku,
      catalogObjectReference: CatalogObjectReference.fromCatalogModel(itemVariation),
      measurementUnitToken: measurementUnit ? measurementUnit.id : null
    });
  }
});